<template>
  <div class="order-line">
    <div class="line-header">
      <div class="order-number">
        订单编号: {{ orderInfo.orderNumber }}
      </div>
      <div class="order-date">
        下单时间: {{ orderInfo.orderDate | parseTime }}
      </div>
      <div class="line-btn" v-if="!hasSubOrder">
        <!-- <el-button class="btn-blue-plain" size="small" @click="viewOrder(orderInfo)">查看详情</el-button> -->
        <el-button class="btn-blue-plain" size="small" @click="viewOrder(orderInfo)">查看详情</el-button>
      </div>
    </div>

    <div class="line-body">
      <div v-if="hasSubOrder">
        <div v-for="subOrder in orderInfo.subOrderList" :key="subOrder.subOrderId" class="sub-order">
          <el-row class="sub-order-header">
            <el-col :span="7" class="sub-order-number">
              子订单编号: {{ subOrder.orderNumber }}
            </el-col>
            <el-col :span="4" class="sub-order-status">
              状态: {{ subOrder.orderStatusName }}
            </el-col>
            <el-col :span="13" class="sub-order-btns">
              <el-button class="btn-blue-plain" size="small" @click="viewOrder(subOrder)">查看详情</el-button>
            </el-col>
          </el-row>
          <OrderLineDetailFreezer :detail-list="subOrder.detailList" />
        </div>
      </div>
      <div v-else>
        <OrderLineDetailFreezer :detail-list="orderInfo.detailList" />
      </div>
    </div>

  </div>
</template>

<script>
import OrderLineDetailFreezer from './order-line-detail-freezer'
export default {
  name: 'order-line',
  components: {
    OrderLineDetailFreezer
  },
  props: {
    orderInfo: {
      type: Object,
      default: () => {
        return {}
      }
    },
    orderType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {}
  },
  computed: {
    hasSubOrder () {
      return this.orderInfo.subOrderList && this.orderInfo.subOrderList.length > 0
    }
  },
  methods: {
    canCancel (subOrder) {
      // TODO 根据子订单状态判断是否可以取消
      return true
    },
    // TODO 这里有疑问，从子订单点击查看详情而不是从主订单吗？？？
    viewOrder (subOrder) {
      this.$router.push({
        path: '/order/info/freezer',
        query: {
          orderId: subOrder.orderId,
          orderType: this.orderType
        }
      })
    },
    cancelOrder (subOrder) {
      // TODO 取消订单操作
    }
  }
}
</script>

<style lang="scss" scoped>
.order-line {
  background-color: $base-lightpink;
  border-radius: 10px;
  padding: 16px 0;
  margin-bottom: 20px;
  position: relative;

  .line-header {
    color: $base-red;
    padding: 0 20px 10px 20px;

    .order-number {
      font-weight: 700;
      line-height: 24px;
      font-size: 16px;
    }
    .order-date {
      font-size: 16px;
      line-height: 24px;
    }
    .line-btn {
      position: absolute;
      top: 22px;
      right: 36px;
    }
  }
  .line-body {
    background-color: $base-white;

    .sub-order {
      margin-bottom: 10px;

      .sub-order-header {
        padding: 15px;
        line-height: 32px;
        border-bottom: 1px solid $base-grey3;

        .sub-order-number {
          font-weight: 700;
        }

        .sub-order-btns {
          text-align: right;
          padding-right: 20px;
        }
      }
    }
  }

}

</style>
